import {
  CONTACT_VALIDATION_PRODUCT_CODE,
  IDENTITY_VERIFICATION_PRODUCT_CODE,
  WIRE_VALIDATION_PRODUCT_CODE,
} from 'features/help/constants';

export interface FraudPreventionService {
  productCode: string;
  productName: string;
  displayName: string;
  iconKey: string;
  description: string;
  price?: string;
}

export const FRAUD_PREVENTION_SERVICES: FraudPreventionService[] = [
  {
    productCode: CONTACT_VALIDATION_PRODUCT_CODE,
    productName: 'Contact Validation',
    displayName: 'Contact Validation',
    iconKey: 'contact-validation',
    price: '$2.00 per validation',
    description:
      "Protect your transactions by quickly gathering information about the party's phone number, email, and street address.",
  },
  {
    productCode: IDENTITY_VERIFICATION_PRODUCT_CODE,
    productName: 'Enhanced Identity Verification',
    displayName: 'Identity Verification',
    iconKey: 'identity-verification',
    price: '$5.00 per ID verification',
    description:
      "Protect your transactions by confirming each party's identity using a government-issued ID and live selfie.",
  },
  {
    productCode: WIRE_VALIDATION_PRODUCT_CODE,
    productName: 'Wire Validation',
    displayName: 'Wire Validation',
    iconKey: 'wire-validation',
    price: '$10.00 per validation',
    description:
      'Validate payee and payoff wire instructions using proprietary technology that makes your wire process faster and more secure.',
  },
];

export const getFraudPreventionServiceDisplayName = (productName: string): string =>
  productName.includes('Enhanced') ? 'Identity Verification' : productName;

export const getFraudPreventionServiceByProductCode = (productCode: string): FraudPreventionService | undefined =>
  FRAUD_PREVENTION_SERVICES.find((service) => service.productCode === productCode);

export const getAdditionalFraudPreventionServices = (
  currentProductCode: string,
  enabledProductCodes: string[],
): FraudPreventionService[] =>
  FRAUD_PREVENTION_SERVICES.filter(
    (service) => service.productCode !== currentProductCode && !enabledProductCodes.includes(service.productCode),
  );
